import { jsx } from "react/jsx-runtime";
import styles from "./CircularProgress.module.css";
const CIRCLE_SIZE = 44;
const THICKNESS = 3.6;
const CircularProgress = ({ ...props }) => {
  return /* @__PURE__ */ jsx("span", { role: "progressbar", className: styles.root, ...props, children: /* @__PURE__ */ jsx(
    "svg",
    {
      role: "img",
      "aria-label": "\u8AAD\u307F\u8FBC\u307F\u4E2D",
      viewBox: `${CIRCLE_SIZE / 2} ${CIRCLE_SIZE / 2} ${CIRCLE_SIZE} ${CIRCLE_SIZE}`,
      children: /* @__PURE__ */ jsx(
        "circle",
        {
          className: styles.circle,
          cx: CIRCLE_SIZE,
          cy: CIRCLE_SIZE,
          r: (CIRCLE_SIZE - THICKNESS) / 2,
          fill: "none",
          strokeWidth: THICKNESS
        }
      )
    }
  ) });
};
export {
  CircularProgress
};
